module.exports = __webpack_public_path__ + "static/media/Slide.553778ab.png";